export enum EntityRoles {
    None = 0,
    DataController = 1,
    DataProcessor = 2,
    DataRecipient = 4,
    ThirdParty = 8,
    SubProcessor = 16
}